export var sharePercent = function (count, total) {
    if (total <= 0) {
        return 0;
    }
    return Math.round((count / total) * 100);
};
